import {mapGetters} from 'vuex'

export default {
    fetchOnServer: true,
    computed:{
        ...mapGetters({
            localeApi: 'core/getApiLangPoint',
        }),
        isRuPage() {
            return this.$route.path.includes("/ru/");
        },
    },
    mounted() {
        setTimeout(async () => {
            await this.$i18n.setLocale(this.isRuPage ? 'ru' : 'ua');
        }, 0);
    }
}
